import Axios from 'axios'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

let axiosProvider = Axios.create({
  baseURL: window.G_BASEURL.API_JYB_BASE_URL,
  timeout: 120000,
  timeRetry: true, // 超时重新请求
  retry: 5, // 请求次数
})

// 请求拦截
axiosProvider.interceptors.request.use(function (config) {
  NProgress.start()

  // 每次请求增加 query 参数 accessToken
  config.url += (config.url.indexOf('?') === -1 ? '?' : '&') +
    'accessToken=' + encodeURIComponent(localStorage.getItem('accessToken'))
  return config
})

// 超时重新请求拦截
axiosProvider.interceptors.response.use(undefined, function axiosRetryInterceptor (err) {
  // if (err.message.indexOf('timeout') === -1) {
  //   return Promise.reject(err)
  // }
  if (err.response) {
    return Promise.reject(err)
  }
  var config = err.config
  // If config does not exist or the retry option is not set, reject
  if (!config || !config.timeRetry) return Promise.reject(err)

  // Set the variable for keeping track of the retry count
  config.__retryCount = config.__retryCount || 0

  // Check if we've maxed out the total number of retries
  if (config.__retryCount >= config.retry) {
    // Reject with the error
    return Promise.reject(err)
  }

  // Increase the retry count
  config.__retryCount += 1

  // Create new promise to handle exponential backoff
  var backoff = new Promise(function (resolve) {
    // const RETRY_TIMEOUTS = [1, 1, 1, 1, 1, 1, 1] // seconds
    // const delay = (RETRY_TIMEOUTS[config.retryCount] || 5) * 1000

    setTimeout(function () {
      resolve()
    }, 1000)
  })

  // Return the promise in which recalls axios to retry the request
  return backoff.then(function () {
    const c = { ...config }
    c.params = { ...c.params, _t: Date.now() }
    return axiosProvider(c).catch(err => {
      err.config.noInterceptorError = true
      return Promise.reject(err)
    })
  })
})
// 响应拦截
axiosProvider.interceptors.response.use(function (res) {
  NProgress.done()

  if (res.config && res.config.noInterceptorError) {
    return res
  }

  if (res.data.error) {
    console.log(res.data.error)
    window.vueApp.$snackbar('Error (2xx):<br/>' + JSON.stringify(res.data.error, null, 4), { color: 'error' })
  } else if (res.data.tsmdResult === 'ERROR') {
    let message = res.data.message
    if (res.data.list && res.data.list.length) {
      message = res.data.list.map(item => item.message).join('<br/>')
    }
    window.vueApp.$snackbar('Error (2xx):<br/>' + message, { color: 'error' })
    res.data.error = message
  }

  return res
}, function (error) {
  NProgress.done()

  // Preserve session expiry handling even when a form displays its own errors.
  if (error.response && error.response.status === 401) {
    localStorage.removeItem('accessToken')
    location.href = '#/login'
  }

  if (error.config && error.config.noInterceptorError) {
    return Promise.reject(error)
  }

  if (error.response) {
    console.log(error.response)
    if (!error.config.noShowError) {
      alert(error.response.status + ' ' + error.response.data.name + ' \n' + error.response.data.message)
    }
  } else {
    if (error.message.indexOf('timeout') > -1) {
      window.vueApp.$snackbar('Error: TIMEOUT<br/>你的网络好像不太好，连接超时了', { color: 'error' })
      // alert('Error:\n' + (error.message || error.Error.message))
    } else {
      window.vueApp.$snackbar('Error:<br/>網路太慢，請檢查網絡', { color: 'error' })
    }
    console.log(error)
    // alert('Error:\n' + (error.message || error.Error.message))
  }

  return Promise.reject(error)
})

export function converParams (params) {
  if (params && params.params) {
    return {
      params: params.params,
      options: {
        ...params,
        params: undefined,
      }
    }
  } else {
    return {
      params: {
        ...params,
      },
      options: undefined
    }
  }
}

export default axiosProvider



// WEBPACK FOOTER //
// ./src/store/axiosProvider.js